module.exports = __webpack_public_path__ + "static/media/modelS_BackgroundPic.e90f1f28.jpg";